import { atom } from "recoil";
import { UserInfo } from "./types";

export const SUPER_ADMIN_ROLE_ID = "24950e1e-5bb1-4a43-a15c-c79845048620";

export const userInfoAtom = atom<UserInfo | undefined>({
  key: "userInfo",
  default: undefined,
});
